export interface Serviser {
  id: string
  region: string
  name: string
  email: string
  phone?: string
}

export const servisers: Serviser[] = [
  {
    id: 'bor',
    region: 'Borski okrug',
    name: 'Bojan Janković',
    email: 'bjankovic@dtech.rs',
    phone: '06x xxx xxx',
  },
  {
    id: 'pancevo',
    region: 'Pančevo – Južnobanatski okrug',
    name: 'Ivan Martinović',
    email: 'imartinovic@dtech.rs',
    phone: '06x xxx xxx',
  },
  {
    id: 'bg-sever',
    region: 'Beograd (Surčin)',
    name: 'Zlatan Zeljić',
    email: 'zzeljic@dtech.rs',
    phone: '06x xxx xxx',
  },
  {
    id: 'bg-jug',
    region: 'Beograd (Zvezdara)',
    name: 'Zlatko Arsić',
    email: 'zarsic@dtech.rs',
    phone: '06x xxx xxx',
  },
]
